import { render, staticRenderFns } from "./zw3.vue?vue&type=template&id=5ab2dc00&scoped=true&"
import script from "./zw3.vue?vue&type=script&lang=js&"
export * from "./zw3.vue?vue&type=script&lang=js&"
import style0 from "./zw3.vue?vue&type=style&index=0&id=5ab2dc00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2dc00",
  null
  
)

export default component.exports